/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BulbAuthServiceProvider,
  BulbBrowserServiceProvider,
  BulbErrorServiceProvider,
  BulbModalServiceProvider, RestangularProvider, TranslateProvider,
} from '../angularjs.providers';

/**
 * Main module to handle on-boarding tour implementation.
 */
@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    BulbAuthServiceProvider,
    BulbBrowserServiceProvider,
    BulbErrorServiceProvider,
    BulbModalServiceProvider,
    RestangularProvider,
    TranslateProvider,
  ],
})
export class TourModule {}
